import {authApi} from "./AuthApiClient";

export async function updateProfileAvatar(file) {
    const formData = new FormData();
    formData.append('file', file);
    return await authApi.patch('/v1/users/avatar', formData,{
        headers: {'Content-Type': 'multipart/form-data'}
    });
}